import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import useAboutStyles from './aboutStyles';
import { cx } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_COLORS } from '../../constants';

const YT_ALLOW = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
const FB_ALLOW = 'autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share';

const IMG = '/static/asset/img/about/';

// Newest first. `quotes` are `{ id, by }` (by: an attribution key rendered
// after the quote); `media` is one embed; `logos` are linked press logos;
// `photos` are captioned stills (`{ src, captionId }`).
const ENTRIES = [
    {
        key: 'm13',
        placeId: 'aboutUs.media.m13.place',
        textId: 'aboutUs.media.m13.description',
        quotes: [{ id: 'aboutUs.media.m13.description1' }],
        links: [
            {
                labelId: 'aboutUs.media.m13.description.zf',
                href: 'https://www.zf.ro/techday/zf-tech-day-marius-mazilu-fondator-virtual-board-solutie-invatamant-22887252?fbclid=IwZXh0bgNhZW0CMTAAYnJpZBEwOHUwd2pqM0ZheGVZcjZOWHNydGMGYXBwX2lkEDIyMjAzOTE3ODgyMDA4OTIAAR7SoOL4SeYYwGjooTrc6EBA208ZtkwAxH91U2Y7hB-CHnxdm9Jq-kZdNWaS9A_aem_O9yvjH3XQ4JUDpcms6J0YQ',
            },
        ],
        media: {
            type: 'video',
            src: 'https://storage1.dms.mpinteractiv.ro/media/1/1481/21332/22887252/1/25august-zf-tech-day-luni-ora-13-00.mp4',
        },
    },
    {
        key: 'm12',
        placeId: 'aboutUs.media.m12.place',
        textId: 'aboutUs.media.m12.description',
        quotes: [{ id: 'aboutUs.media.m12.description1' }, { id: 'aboutUs.media.m12.description2' }],
        links: [
            {
                labelId: 'aboutUs.media.m12.description.edupedu1',
                href: 'https://www.edupedu.ro/video-profesorul-poate-vedea-pe-tabla-interactiva-toti-elevii-separat-si-pentru-fiecare-poate-evalua-ceea-ce-face-isi-pot-descarca-ce-au-lucrat-dar-lectia-ramane-in-aplicatie-si-nu-mai-e-nevoie-de-s/',
            },
            {
                labelId: 'aboutUs.media.m12.description.edupedu2',
                href: 'https://www.edupedu.ro/ministrul-educatiei-si-cercetarii-daniel-david-invitat-la-conferinta-nationala-pentru-profesori-nexted-teach-learn-create-display-vineri-28-martie-in-aula-academiei-de-studii-economice-din-buc/',
            },
        ],
        media: { type: 'youtube', src: 'https://www.youtube.com/embed/_sIZJXIRNt8?si=mlxohbpoZpFxY6_M', title: 'EduPedu' },
    },
    {
        key: 'm11',
        placeId: 'aboutUs.media.m11.place',
        textId: 'aboutUs.media.m11.description',
        quotes: [
            { id: 'aboutUs.media.m11.description1' },
            { id: 'aboutUs.media.m11.description2' },
            { id: 'aboutUs.media.m11.description3' },
            { id: 'aboutUs.media.m11.description4' },
        ],
        links: [
            {
                labelId: 'aboutUs.media.m11.description.orange',
                href: 'https://newsroom.orange.ro/comunicate/comunitatile-din-delta-dunarii-vor-avea-acces-la-tehnologia-5g-orange-prin-intermediul-unui-proiect-cu-finantare-europeana/',
            },
            {
                labelId: 'aboutUs.media.m11.description.zf',
                href: 'https://www.zf.ro/business-hi-tech/orange-romania-merge-cu-reteaua-5g-si-in-delta-dunarii-printr-un-22530320',
            },
            {
                labelId: 'aboutUs.media.m11.description.hotnews',
                href: 'https://hotnews.ro/comunitatile-din-delta-dunarii-vor-avea-acces-la-tehnologia-5g-orange-prin-intermediul-unui-proiect-cu-finantare-europeana-1824522',
            },
            {
                labelId: 'aboutUs.media.m11.description.protv',
                href: 'https://stirileprotv.ro/s/p-peste-20-000-de-locuitori-din-delta-dunarii-vor-beneficia-de-acces-la-tehnologie-prin-proiectul-5g-connect-danube-delta.html',
            },
        ],
    },
    {
        key: 'm3',
        placeId: 'aboutUs.media.m3.place',
        textId: 'aboutUs.media.m3.description',
        quotes: [{ id: 'aboutUs.media.m3.description1' }, { id: 'aboutUs.media.m3.description2' }],
        links: [
            {
                labelId: 'aboutUs.media.m3.description.edupedu',
                href: 'https://www.edupedu.ro/video-profesorul-controleaza-interactivitatea-cu-elevul-ghideaza-clasa-spune-marius-mazilu-fondatorul-vboard-aplicatia-nativa-pe-tablele-interactive-nu-ne-permitem-ca-procesul-educational-sa-ias/',
            },
        ],
        media: { type: 'youtube', src: 'https://www.youtube.com/embed/aOFHyo-vIAI?si=ackqptKtCGrptWRx', title: 'EduPedu' },
    },
    {
        key: 'm4',
        placeId: 'aboutUs.media.m4.place',
        textId: 'aboutUs.media.m4.description',
        quotes: [],
        links: [],
        media: { type: 'youtube', src: 'https://www.youtube.com/embed/BkihbnkeSKU?si=5pIL_GUjWC5x_S3J', title: 'Tech Expo 2024' },
    },
    {
        key: 'm5',
        placeId: 'aboutUs.media.m5.place',
        textId: 'aboutUs.media.m5.description',
        quotes: [
            { id: 'aboutUs.media.m5.description1', by: 'aboutUs.media.m5.description1.1' },
            { id: 'aboutUs.media.m5.description2', by: 'aboutUs.media.m5.description2.1' },
        ],
        links: [
            {
                labelId: 'aboutUs.media.m5.description.protv',
                href: 'https://www.protv.ro/emisiuni/imperiul-leilor/articol/95513-imperiul-leilor-21-noiembrie-2023-marius-mazilu-foloseste-tehnologia-pentru-a-revolutiona-sistemul-educational-ce-au-spus-leii-despre-afacerea-lui',
            },
        ],
        media: { type: 'youtube', src: 'https://www.youtube.com/embed/aVzIWa-l5cw?si=pmaIs53ZIrnqUM5j', title: 'Imperiul Leilor' },
    },
    {
        key: 'm6',
        placeId: 'aboutUs.media.m6.place',
        textId: 'aboutUs.media.m6.description',
        quotes: [{ id: 'aboutUs.media.m6.description1' }],
        links: [],
        media: {
            type: 'facebook',
            src: 'https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F100040195164162%2Fvideos%2F793068531958004%2F&show_text=false&width=560&t=0',
            title: 'Romanian Digital Day',
        },
    },
    {
        key: 'm7',
        placeId: 'aboutUs.media.m7.place',
        textId: 'aboutUs.media.m7.description',
        quotes: [{ id: 'aboutUs.media.m7.description1' }],
        links: [
            {
                labelId: 'aboutUs.media.m7.description.start-up',
                href: 'https://start-up.ro/vboard-romanii-care-vor-sa-puna-o-tabla-virtuala-in-orice-clasa/',
            },
        ],
        media: { type: 'youtube', src: 'https://www.youtube.com/embed/1hEMGGFI-UU?si=q7dKtcWs85cN0fw9', title: 'Vivatech 2022' },
    },
    {
        key: 'm8',
        placeId: 'aboutUs.media.m8.place',
        textId: 'aboutUs.media.m8.description',
        quotes: [{ id: 'aboutUs.media.m8.description1.express' }, { id: 'aboutUs.media.m8.description1.zf' }],
        links: [],
        logos: [
            {
                href: 'https://expressdebanat.ro/povestea-timisoreanului-marius-mazilu-care-ofera-o-solutie-impotriva-celei-mai-mari-probleme-create-de-covid-19/',
                src: 'https://expressdebanat.ro/wp-content/uploads/2021/07/logo-site-3.png',
                alt: 'Express de Banat',
            },
            {
                href: 'https://www.zf.ro/zf-it-generation/zf-it-generation-start-up-pitch-marius-mazilu-fondator-vboard-20289489',
                src: 'https://www.zf.ro/images/Logo%20+%20Slogan.png',
                alt: 'Ziarul Financiar',
            },
        ],
    },
    {
        key: 'm9',
        placeId: 'aboutUs.media.m9.place',
        textId: 'aboutUs.media.m9.description',
        quotes: [{ id: 'aboutUs.media.m9.description1' }, { id: 'aboutUs.media.m9.description2' }],
        links: [],
        // The Facebook live recording these used to link to is gone, so the
        // card shows one photo of each award ceremony instead.
        photos: [
            { src: `${IMG}InnovationLabs2021ScaleUp.jpg`, captionId: 'aboutUs.media.m9.description.scaleUp' },
            { src: `${IMG}InnovationLabs2021Orange.jpg`, captionId: 'aboutUs.media.m9.description.orange' },
        ],
    },
    {
        key: 'm10',
        placeId: 'aboutUs.media.m10.place',
        textId: 'aboutUs.media.m10.description',
        quotes: [{ id: 'aboutUs.media.m10.description1' }],
        links: [],
        media: {
            type: 'facebook',
            src: 'https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FTVRTimisoara%2Fvideos%2F1053505232153653%2F&show_text=false&width=560&t=236',
            title: 'TVR Timișoara',
        },
    },
];

const useStyles = makeStyles(() => ({
    single: {
        gridTemplateColumns: 'minmax(0, 1fr)',
    },
    logos: {
        display: 'grid',
        gap: '16px',
        justifyItems: 'center',
    },
    logoLink: {
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        padding: '18px 24px',
        border: `1px solid ${REDESIGN_COLORS.sand}`,
        borderRadius: '16px',
        background: REDESIGN_COLORS.white,
        textAlign: 'center',
        '&:hover': {
            borderColor: REDESIGN_COLORS.primary,
        },
    },
    logoImg: {
        maxWidth: '220px',
        width: '100%',
        height: 'auto',
    },
    photos: {
        display: 'grid',
        gap: '16px',
    },
    photo: {
        display: 'block',
        width: '100%',
        height: 'auto',
        borderRadius: '12px',
        boxShadow: '0 1px 2px rgba(6, 63, 69, 0.06), 0 16px 40px rgba(6, 63, 69, 0.12)',
    },
    caption: {
        margin: '10px 0 0',
        textAlign: 'center',
        color: REDESIGN_COLORS.muted,
        fontSize: '0.86rem',
        fontWeight: 600,
    },
}));

const Embed = ({ media, classes }) => (
    <div className={classes.ratio}>
        {media.type === 'video' ? (
            <video controls preload="metadata" className={classes.embed}>
                <source src={media.src} type="video/mp4" />
            </video>
        ) : (
            <iframe
                src={media.src}
                title={media.title}
                loading="lazy"
                allow={media.type === 'facebook' ? FB_ALLOW : YT_ALLOW}
                allowFullScreen
                className={classes.embed}
            />
        )}
    </div>
);

const AboutMedia = () => {
    const classes = useAboutStyles();
    const own = useStyles();

    return (
        <>
            <div className={classes.head}>
                <h2 className={classes.h2}>
                    <FormattedMessage id="aboutUs.media.button" />
                </h2>
                <p className={classes.lead}>
                    <FormattedMessage id="redesign.about.media.lead" />
                </p>
            </div>

            {ENTRIES.map((entry, index) => {
                const hasSide = Boolean(entry.media || entry.logos || entry.photos);

                return (
                    <article key={entry.key} className={classes.card}>
                        <div
                            className={cx(
                                classes.row,
                                !hasSide && own.single,
                                hasSide && index % 2 === 1 && classes.rowFlipped
                            )}
                        >
                            <div>
                                <h3 className={classes.h3}>
                                    <FormattedMessage id={entry.placeId} />
                                </h3>
                                <p className={classes.text}>
                                    <FormattedMessage id={entry.textId} />
                                </p>
                                {entry.quotes.map((quote) => (
                                    <blockquote key={quote.id} className={classes.quote}>
                                        <FormattedMessage id={quote.id} />
                                        {quote.by ? (
                                            <cite>
                                                <FormattedMessage id={quote.by} />
                                            </cite>
                                        ) : null}
                                    </blockquote>
                                ))}
                                {entry.links.length ? (
                                    <div className={classes.links}>
                                        {entry.links.map((link) => (
                                            <a
                                                key={link.href}
                                                href={link.href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={classes.external}
                                            >
                                                <FormattedMessage id={link.labelId} />
                                                <span aria-hidden="true">↗</span>
                                            </a>
                                        ))}
                                    </div>
                                ) : null}
                            </div>

                            {entry.media ? (
                                <div className={classes.frame}>
                                    <Embed media={entry.media} classes={classes} />
                                </div>
                            ) : null}

                            {entry.photos ? (
                                <div className={own.photos}>
                                    {entry.photos.map((photo) => (
                                        <figure key={photo.src} className={classes.frame} style={{ margin: 0 }}>
                                            <img src={photo.src} alt="" loading="lazy" className={own.photo} />
                                            <figcaption className={own.caption}>
                                                <FormattedMessage id={photo.captionId} />
                                            </figcaption>
                                        </figure>
                                    ))}
                                </div>
                            ) : null}

                            {entry.logos ? (
                                <div className={own.logos}>
                                    {entry.logos.map((logo) => (
                                        <a
                                            key={logo.href}
                                            href={logo.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={own.logoLink}
                                        >
                                            <img src={logo.src} alt={logo.alt} loading="lazy" className={own.logoImg} />
                                        </a>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    </article>
                );
            })}
        </>
    );
};

export default AboutMedia;
